import axios from 'axios';
import { FrontendForgeUser } from './model/frontend/FrontendForgeUser';
import { plainToClass } from 'class-transformer';
import { PaginationRequest } from './util/PaginationParameters';

let isDisplayingError = false;

export class FrontendAPIHelper {
  public async callEndpoint<TResponse>(
    responseType: new () => TResponse,
    method: "GET" | "DELETE",
    path: string,
    pagination: PaginationRequest,
    headers?: Record<string, string>
  ): Promise<TResponse>;
  public async callEndpoint<TResponse>(
    responseType: new () => TResponse,
    method: "POST" | "PATCH" | "PUT",
    path: string,
    pagination: PaginationRequest,
    body?: any,
    headers?: Record<string, string>
  ): Promise<TResponse>;
  public async callEndpoint<TResponse>(
    responseType: new () => TResponse,
    method: "GET" | "DELETE" | "POST" | "PATCH" | "PUT",
    path: string,
    pagination: PaginationRequest,
    optionalBody?: any,
    optionalHeaders?: Record<string, string>
  ): Promise<TResponse> {
    const isBodyAllowed = ["POST", "PATCH", "PUT"].includes(method);
    const body = isBodyAllowed ? optionalBody : undefined;
    const headers = (isBodyAllowed ? optionalHeaders : optionalBody) ?? {};
    try {
      let response = await axios({
        method: method,
        url: `/api/v1/${path}`,
        params: { pagination },
        data: isBodyAllowed ? body : undefined,
        headers: {
          "Content-Type": "application/json",
          ...headers,
        },
      });
      return plainToClass(responseType, response.data);
    } catch (e) {
      let errorMessage = e.response?.data?.error;

      if (errorMessage && !isDisplayingError) {
        isDisplayingError = true;

        let vue: Vue = (window as any).vue;

        vue.$buefy.snackbar.open({
          indefinite: true,
          message: errorMessage,
          actionText: "OK",
          type: "is-danger",
          position: "is-bottom-right",
          queue: false,
          onAction: () => {
            isDisplayingError = false;
          },
        });
      }

      throw e;
    }
  }

  public async callUploadEndpoint<TResponse>(
    responseType: new () => TResponse,
    method: "PUT",
    path: string,
    body?: any,
    headers?: Headers
  ): Promise<TResponse> {
    try {
      let response = await axios({
        method: method,
        url: `/api/v1/${path}`,
        data: body,
        headers: headers,
      });
      return plainToClass(responseType, response.data);
    } catch (e) {
      let errorMessage = e.response?.data?.error;

      if (errorMessage && !isDisplayingError) {
        isDisplayingError = true;

        let vue: Vue = (window as any).vue;

        vue.$buefy.snackbar.open({
          indefinite: true,
          message: errorMessage,
          actionText: "OK",
          type: "is-danger",
          position: "is-bottom-right",
          queue: false,
          onAction: () => {
            isDisplayingError = false;
          },
        });
      }

      throw e;
    }
  }
}
